import React from "react";
import "./styles/ContactUs.css"

export class ContactUs extends React.Component{
    render() {
        return(
            <div className="contact-us"></div>
        )
    }
}